import React, { Component } from 'react';
import style from './BackDropLoading.module.css';

class BackDropLoading extends Component {
   
    render() {
        
        let item = [];

        if(this.props.show === true){
            item.push(
                <div className={style.area} key={1}>
                    <div className={style.loader}></div>
                </div>
            );
        }
        return item;
    }
}
export default BackDropLoading;